<template>
    <div style="position: relative">
        <v-btn
            v-if="setup.img !== undefined"
            absolute
            dark
            fab
            small
            top
            right
            color="red"
            @click.prevent="removeAvatar()"
        >
            <v-icon>mdi-minus</v-icon>
        </v-btn>
        <v-avatar :tile="setup.img !== undefined && setup.tile === true" size="128" :color="(setup.color) ? setup.color : 'primary'" class="mb-2">
            <img v-if="setup.img !== undefined" :src="setup.img" :alt="setup.name">
            <span class="white--text headline" v-else-if="setup.name !== undefined">{{ setup.name | initialName }}</span>
            <span class="white--text headline" v-else> {{ setup.placeholder }} </span>
        </v-avatar>
        <v-btn color="primary" dark @click.prevent="selectAvatar()" block>{{ formAvatarBtnTitle }}</v-btn>
        <v-file-input
            id="avatar"
            ref="avatar"
            class="d-none"
            accept="image/png, image/jpeg, image/bmp"
            @change="previewAvatar"
        ></v-file-input>
    </div>
</template>

<script>
export default {
    name: 'input-avatar',
    props: ['setup'],
    computed: {
        formAvatarBtnTitle () {
            return (this.setup.img != null) ? this.$t('common.change') : this.$t('common.add')
        }
    },
    methods: {
        removeAvatar () {
            this.setup.img = undefined
            this.setup.file = undefined
            this.setup.dirty = true
        },
        selectAvatar () {
            document.querySelector('#avatar').click()
        },
        previewAvatar (file) {
            let reader = new FileReader()
            const vm = this
            reader.onload = (file) => {
                vm.setup.img = file.target.result
                vm.setup.dirty = true
            }
            reader.readAsDataURL(file)
            this.setup.file = file
        }
    }
}
</script>
